import React, { useContext, useEffect, useState } from "react";
import PlayerContext from "../context/Player-context";
import { useNavigate } from "react-router-dom";
import LoadScreen from "../components/Load-screen";
import axios from "axios";
import CategoryCarousel from "../components/category-carousel";
import SearchBar from "../components/SearchBar";

export default function Player() {
  const { setSelectedCategory } = useContext(PlayerContext);
  const [groups, setGroups] = useState<string[]>([]);
  const [defaultGroup, setDefaultGroup] = useState<string[]>([]);

  const [isLoaded, setIsLoaded] = useState(false);

  const [searchTerm, setSearchTerm] = useState<string>();

  const navigate = useNavigate();

  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const getFromUrl = async () => {
      // Use API URL to get categories from server
      // Navigate back if there is error or if there are no categories
      try {
        const { data } = await axios.get<string[]>(`${apiUrl}/m3u`);

        if (!data.length) navigate(-1);

        setGroups(data);

        setDefaultGroup(data);

        setIsLoaded(true);
      } catch (error) {
        navigate(-1);
      }
    };

    getFromUrl();
  }, [apiUrl, navigate]);

  const handleGroupClick = (group: string) => {
    // Set the selected category then navigate to subcategory
    setSelectedCategory(group);
    navigate("/subcategory");
  };

  const handleSearch = () => {
    if (!searchTerm) return;

    const lowGroup = groups.map((item) => item.toLowerCase());

    const filteredGroup = lowGroup.filter((item) =>
      item.includes(searchTerm.toLowerCase())
    );

    setGroups(filteredGroup);
  };

  const clearSearch = () => {
    setGroups(defaultGroup);
  };

  return (
    <React.Fragment>
      {!isLoaded && <LoadScreen />}
      {isLoaded && (
        <div className="bg-gray-800 flex flex-col h-screen">
          <div className="h-[30%]">
            {/* Nav bar */}
            <div className="p-2 my-2 text-center">
              <span
                className="cursor-pointer font-bold uppercase text-blue-700 font-mono px-4 py-2 bg-slate-300 rounded-md"
                onClick={() => navigate(0)}
              >
                Refresh
              </span>
            </div>

            {/* Search bar */}
            <SearchBar
              onChangeTerm={(e) => setSearchTerm(e.currentTarget.value)}
              onSearch={handleSearch}
              onCancel={clearSearch}
              placeholder="Search Categories"
            />
          </div>

          {/* group */}
          <div className="h-[70%] flex items-center justify-center">
            <CategoryCarousel category={groups} action={handleGroupClick} />
          </div>
        </div>
      )}
    </React.Fragment>
  );
}
